
import React from "react";

export default function DeleteAccount() {
  return (
    <div className="delete-account-page">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-body p-4 p-md-5">
                <div className="text-center mb-4">
                  <div
                    className="rounded-circle bg-light d-inline-flex
                    align-items-center justify-content-center mb-3"
                    style={{ width: 80, height: 80 }}
                  >
                    <span style={{ fontSize: 42 }}>🐾</span>
                  </div>

                  <h1 className="fw-bold text-dark">
                    PET PLAZZA
                  </h1>

                  <h2 className="h4 text-secondary mt-3">
                    Account and Data Deletion
                  </h2>
                </div>

                <p className="text-muted">
                  Welcome to PET PLAZZA. This page explains how
                  users can request the deletion of their personal
                  data associated with the PET PLAZZA app.
                </p>

                <hr />

                <h3 className="h5 fw-bold mt-4">
                  1. Account Creation
                </h3>

                <p>
                  The PET PLAZZA app does not allow users to
                  create an account. Therefore, users do not
                  have an in-app account to delete.
                </p>

                <h3 className="h5 fw-bold mt-4">
                  2. Request Personal Data Deletion
                </h3>

                <p>
                  If you believe that PET PLAZZA has collected
                  or stored personal data associated with your
                  use of the app, you can request its deletion
                  by contacting us through the email address
                  below.
                </p>

                <div className="bg-light rounded-3 p-3 my-3">
                  <p className="mb-2 fw-semibold">
                    Email your data deletion request to:
                  </p>

                  <a
                    href="mailto: petplazzainfo001@gmail.com?subject=PET%20PLAZZA%20Data%20Deletion%20Request"
                    className="text-decoration-none fw-bold"
                  >
                     petplazzainfo001@gmail.com
                  </a>

                  <p className="small text-muted mt-2 mb-0">
                    Please mention "PET PLAZZA Data Deletion
                    Request" in your email.
                  </p>
                </div>

                <h3 className="h5 fw-bold mt-4">
                  3. Data That May Be Deleted
                </h3>

                <p>
                  After reviewing your request, we will delete
                  eligible personal data associated with your
                  use of the app, where applicable. This may
                  include contact details or other personal
                  information collected by the app, if any.
                </p>

                <h3 className="h5 fw-bold mt-4">
                  4. Data Retention
                </h3>

                <p>
                  If certain data must be retained for legal,
                  security, fraud prevention, or other legitimate
                  requirements, it will be retained only for the
                  applicable retention period. Data that is no
                  longer required will be deleted securely.
                </p>

                <h3 className="h5 fw-bold mt-4">
                  5. Processing Your Request
                </h3>

                <p>
                  We will review your request and may contact
                  you if additional information is needed to
                  process it. We will inform you of the outcome
                  where appropriate.
                </p>

                <h3 className="h5 fw-bold mt-4">
                  6. Contact Us
                </h3>

                <p className="mb-1">
                  <strong>App Name:</strong> PET PLAZZA
                </p>

                <p className="mb-1">
                  <strong>Company Name:</strong> Bengal Pet
                </p>

                <p className="mb-0">
                  <strong>Email:</strong>{" "}
                  <a href="mailto: petplazzainfo001@gmail.com">
                     petplazzainfo001@gmail.com
                  </a>
                </p>

                <hr className="my-4" />

                <p className="small text-muted text-center mb-0">
                  © {new Date().getFullYear()} PET PLAZZA.
                  All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
